/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { DisputeSuccessMessage } from '../../../components/disputeSuccessMessage/DisputeSuccessMessage';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { formatDateISO8601 } from '../../../utils/dateFormat';
import { IResolveDispute } from '../../../utils/types';
import { color, transformDataDisputeForm } from '../data-adapter';
import '../dispute.scss';
import { useGetDisputesQuery, useUpdateDisputeMutation } from '../disputeSlice';
import { EditFormDispute } from '../editFormDispute/EditFormDispute';
import { recalculateAssociate } from '../../../components/recalculateAssociate/recalculateAssociate';
import { useGetPayoutDailyDisputeMetricsQuery } from '../../../pages/metricdashboard/metricDashboardSlice';

type editDisputeProps = {
    disputeDialogEnable: boolean;
    closeAllDisputes: (message: boolean) => void;
    empDailyResultId: number;
    disputeIds: string[];
    employeeNo: number;
    // monthlyMetricsData: any;
    seletedRowData: any;
    isMangerWindowOpen: boolean;
    setDisputeDialogEnable: React.Dispatch<React.SetStateAction<boolean>>;
    scorecardVersionId?: number;
    year?: number;
    month?: number;
};

export const EditDispute = ({
    disputeDialogEnable,
    closeAllDisputes,
    empDailyResultId,
    disputeIds,
    employeeNo,
    // monthlyMetricsData,
    seletedRowData,
    isMangerWindowOpen,
    setDisputeDialogEnable,
    scorecardVersionId,
    year,
    month,
}: editDisputeProps) => {
    const [UpdateDispute] = useUpdateDisputeMutation();
    const [formFields, setFormFields] = useState<any>([]);
    const [errorMessage, setErrorMessage] = useState<any>();
    const [addDisputeEmpty, setAddDisputeEmpty] = useState<boolean>(false);
    const [disableSave, setDisableSave] = useState<boolean>(true);
    const loggedUserEmpId = useSelector(selectCurrentEmpid);
    const loggedEmpNum = useSelector(selectCurrentEmpid);

    const { data: disputesData, isFetching: disputesDataIsFetching } = useGetDisputesQuery(
        { disputeIds },
        { skip: !(disputeIds.length > 0) }
    );

    const { data: payoutDailyDisputeMetrics } = useGetPayoutDailyDisputeMetricsQuery(
        {
            employeenumber: employeeNo?.toString(),
            year,
            month,
            scorecardVersionId,
        },
        { skip: !employeeNo || !year || !month || !scorecardVersionId }
    );

    const handleFormChange = (event: any, index: number) => {
        const data = [...formFields];
        if (event.target.name === 'metricId') {
            const metricids = data.filter((x: any) => x.metricId === event.target.value);
            if (metricids.length > 0) {
                toast.warn('Dispute is already created for this metric');
                data[index][event.target.name] = 0;
                data[index].disputedValue = '';
            } else {
                const b = seletedRowData.colHeaderNames.split('$');
                const a = payoutDailyDisputeMetrics?.data.filter((x: any) => x.metric_id === event.target.value);
                let i = b.findIndex((x: any) => {
                    data[index][event.target.name] = event.target.value;
                    data[index].metricName = a[0].metric_name;
                    return x === a[0].metric_name;
                });
                i += 2;
                data[index].disputedValue =
                    seletedRowData['col' + i] === '--' ? undefined : seletedRowData['col' + i];
            }
        } else data[index][event.target.name] = event.target.value;
        setFormFields(data);
    };

    const hideDisputeDialog = () => {
        setDisputeDialogEnable(false);
        closeAllDisputes(false);
    };

    const addDispute = () => {
        if (isMangerWindowOpen) {
            toast.warn('Sorry, you cannot create a dispute once the associate approval window has closed.');
            return;
        }

        const dispute: IResolveDispute = {
            empDailyResultId,
            metricId: 0,
            metricName: '',
            disputedValue: undefined,
            disputeReasonid: 0,
            proposedValue: undefined,
            disputeComment: '',
            disputeId: 0,
            employeeNumber: employeeNo.toString(),
            disputeCreateBy: loggedUserEmpId,
            disputeCreateDate: new Date().toLocaleString('en-US', { dateStyle: 'medium' }),
            disputeDate: formatDateISO8601(seletedRowData?.metric_date),
            resolutionComment: '',
            resolutionReasonId: 0,
            resolvedBy: '',
            metricHeaderColor: color[formFields.length + 1],
            resolutionClicked: false,
        };
        setFormFields([...formFields, dispute]);
    };

    const saveMetricDisputeClicked = () => {
        let disputeList: IResolveDispute[] = [];
        disputeList = formFields;
        const isformValid = validateForm();
        if (isformValid) {
            setErrorMessage('');
            setDisableSave(true);
            UpdateMetricDispute(disputeList);
        } else {
            console.log('Error');
        }
    };

    const validateForm = (): boolean => {
        let disputeList: IResolveDispute[] = [];
        disputeList = formFields;
        for (let i = 0; i < disputeList.length; i++) {
            const dispute: IResolveDispute = disputeList[i];
            if (dispute.metricId === 0) {
                setErrorMessage('Please select Metrics');
                return false;
            }
            if (dispute.disputeReasonid === 0) {
                setErrorMessage('Please select Dispute reason');
                return false;
            }

            if (dispute.disputeComment === '') {
                setErrorMessage('Please enter dispute comment.');
                return false;
            }
            const disputedValue = dispute.disputedValue?.toString().replace(/[^a-zA-Z0/.00-9/.99 ]/g, '');
            const proposedValue = dispute.proposedValue?.toString().replace(/[^a-zA-Z0/.00-9/.99 ]/g, '');

            if (disputedValue && proposedValue === disputedValue) {
                setErrorMessage('Expected Value and Disputed value should not be same.');
                return false;
            }
            if (dispute.resolutionClicked) {
                if (dispute.resolutionReasonId === 0) {
                    setErrorMessage('Please select Resolution Reason.');
                    return false;
                }
                if (dispute.resolutionComment === '' || dispute.resolutionComment === null) {
                    setErrorMessage('Please enter Resolution comment.');
                    return false;
                }
            }
        }
        return true;
    };

    const UpdateMetricDispute = (disputes: any) => {
        const data = {
            disputes,
        };
        UpdateDispute(data)
            .unwrap()
            .then(() => {
                const hasResolutionClicked = disputes.some((dispute: any) => dispute.resolutionClicked);

                if (hasResolutionClicked) {
                    recalculateAssociate(employeeNo.toString(), scorecardVersionId, year, month, loggedUserEmpId);

                }

                setAddDisputeEmpty(true);
                setDisableSave(true);
                toast.success('Save Success');
            })
            .then((error: any) => {
                console.log(error);
                setDisableSave(true);
            });
    };

    const removeDispute = (index: number) => {
        const data = [...formFields];
        data.splice(index, 1);
        setFormFields(data);
    };

    const ResolveDisputeClick = (index: any) => {
        const data = [...formFields];
        data[index].resolutionClicked = true;
        setFormFields(data);
        setDisableSave(true);
    };

    useEffect(() => {
        if (disputesData?.data?.length > 0) {
            const disputes: IResolveDispute[] = transformDataDisputeForm(
                disputesData.data,
                empDailyResultId,
                loggedEmpNum?.toString(),
                employeeNo?.toString()
            );
            setFormFields(disputes);
            setDisableSave(false);
        }
    }, [disputesData]);

    useEffect(() => {
        const isformValid = validateForm();
        if (isformValid) {
            setDisableSave(false);
            setErrorMessage('');
        } else setDisableSave(true);
    }, [errorMessage, formFields]);

    const disputeModalHeader = () => {
        return (
            <>
                <div>
                    <h5 className="pe-3">
                        <span style={{ fontSize: '16px', fontWeight: 700 }} className="pt-2">
                            Edit Dispute
                        </span>
                    </h5>
                    <span className="error-text" id="errMessage">
                        {errorMessage}
                    </span>
                </div>
                <div>
                    <Button
                        disabled={formFields.length > 4}
                        visible={!disputesDataIsFetching}
                        className="btn-secondary w-auto float-end"
                        onClick={addDispute}
                    >
                        Add Dispute
                    </Button>
                </div>
            </>
        );
    };

    const disputeModalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    disabled={disableSave}
                    className="btn-primary w-auto float-end"
                    onClick={saveMetricDisputeClicked}
                >
                    Save Changes
                </Button>
                <Button
                    className="btn-secondary w-auto float-end"
                    onClick={hideDisputeDialog}
                >
                    Cancel
                </Button>
            </React.Fragment>
        );
    };

    return (
        <Dialog
            visible={disputeDialogEnable}
            style={{ width: '50vw' }}
            header={!addDisputeEmpty ? disputeModalHeader : ''}
            modal
            className="p-fluid disputeModal"
            onHide={hideDisputeDialog}
            footer={!addDisputeEmpty ? disputeModalFooter : ''}
        >
            <>
                {addDisputeEmpty && (
                    <DisputeSuccessMessage successMsg="Updated" closeAllDisputes={closeAllDisputes} />
                )}

                {!addDisputeEmpty && (
                    <div className="row">
                        {formFields?.map((dispute: any, index: number) => {
                            return (
                                <React.Fragment key={dispute.disputeId}>
                                    <EditFormDispute
                                        dispute={dispute}
                                        index={index}
                                        payoutDailyDisputeMetrics={payoutDailyDisputeMetrics}
                                        handleFormChange={handleFormChange}
                                        removeDispute={removeDispute}
                                        ResolveDisputeClick={ResolveDisputeClick}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </>
        </Dialog>
    );
};
